import styles from './styles/Features.css'
import PlanData from '../../../config/static/pricing-plans'
import Header from '../typography/Header'

export const FeatureCopy = ({ plan }) => (
  <div className={styles.featuresLayout}>
    <div className={styles.features}>
      {PlanData[plan].featureCopy.map(({ header, content }, index) => (
        <div key={index} className={styles.feature}>
          <div className={styles.featureTitle}>{header}</div>
          {content.map((copy, i) => (
            <div key={i} className={styles.featureCopy}>{copy}</div>
          ))}
        </div>
      ))}
    </div>
  </div>
)

export const Features = ({ plan }) => {
  return (
    <div className={styles.featuresLayout}>
      <Header className={styles.featureHeader} level={3}>{PlanData[plan].featureHeader}</Header>
      <ul className={styles.features}>
        {PlanData[plan].features.map((feature, index) => (
          <li key={index} className={styles.feature}>{feature}</li>
        ))}
      </ul>
    </div>
  )
}
